export default __webpack_public_path__ + "static/media/ecell.49df7f0e.png";